<template>

    <vx-card :title="$t('Services')">

        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="tasks">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <vs-button v-if="this.offerUser && this.status < 2" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addOfferTaskPrompt = true">{{$t("Add")}}</vs-button>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="title">{{$t("TaskTitle")}}</vs-th>
                <vs-th sort-key="description">{{$t("Description")}}</vs-th>
                <vs-th sort-key="hours">{{$t("HourNumber")}}</vs-th>
                <vs-th sort-key="deadline_days">{{$t("DeadlineFromStart")}}</vs-th>
                <vs-th sort-key="branch_office_id">{{$t("BranchOffice")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].title">
                        {{ data[index].title }}
                    </vs-td>

                    <vs-td :data="data[index].description">
                        {{ data[index].description }}
                    </vs-td>

                    <vs-td :data="data[index].hours">
                        {{ data[index].hours }}
                    </vs-td>

                    <vs-td :data="data[index].deadline_days">
                        {{ data[index].deadline_days }}
                    </vs-td>

                    <vs-td v-if="branchOffices" :data="data[index].branch_office_id">
                        {{ branchOfficeMap[data[index].branch_office_id].title }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" v-if="this.offerUser && this.status < 2" :active.sync="addOfferTaskPrompt">
            <div>
                <p class="mt-6">{{$t("TaskTitle")}}</p>
                <vs-input v-model="offerTaskAdding['title']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Quantity")}}</p>
                <vs-input v-model="offerTaskAdding['quantity']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("HourNumber")}}</p>
                <vs-input v-model="offerTaskAdding['hours']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("DeadlineFromStart")}}</p>
                <vs-input v-model="offerTaskAdding['deadline_days']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("BranchOffice")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="offerTaskAdding['branch_office_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in this.branchOffices" />
                </vs-select>
                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea v-model="offerTaskAdding['description']" class="w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addOfferTask">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editOfferTaskPrompt">
            <div>
                <p class="mt-6">{{$t("TaskTitle")}}</p>
                <vs-input :disabled="!(this.offerUser && this.status < 2)" v-model="offerTaskEdit['title']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Quantity")}}</p>
                <vs-input :disabled="!(this.offerUser && this.status < 2)" v-model="offerTaskEdit['quantity']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("HourNumber")}}</p>
                <vs-input :disabled="!(this.offerUser && this.status < 2)" v-model="offerTaskEdit['hours']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("DeadlineFromStart")}}</p>
                <vs-input :disabled="!(this.offerUser && this.status < 2)" v-model="offerTaskEdit['deadline_days']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("BranchOffice")}}</p>
                <vs-select :disabled="!(this.offerUser && this.status < 2)" autocomplete style="width: 100%" class="selectExample" v-model="offerTaskEdit['branch_office_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in this.branchOffices" />
                </vs-select>
                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea :disabled="!(this.offerUser && this.status < 2)" v-model="offerTaskEdit['description']" class="w-full" />
                <vs-divider/>
                <vs-button v-if="this.offerUser && this.status < 2" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editOfferTask">{{$t("Change")}}</vs-button>
                <vs-button v-if="this.offerUser && this.status < 2" style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeOfferTask">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>

</template>
<script>

    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            clientCompanyId: {
                type: Number,
                required: true
            },
            offerUser: {
                type: Boolean,
                required: true
            },
            status: {
                type: Number,
                required: false,
                default: 0
            }
        },
        data(){
            return {

                selected: {},

                tasks: null,

                branchOffices: [],

                addOfferTaskPrompt: false,
                editOfferTaskPrompt: false,

                offerTaskAdding: {},
                offerTaskEdit: {},
            }
        },
        computed: {
            branchOfficeMap(){

                let branchMap = {};
                for(let x = 0; x < this.branchOffices.length; x++){
                    branchMap[this.branchOffices[x].id] = this.branchOffices[x];
                }

                return branchMap;
            }
        },
        methods: {
            handleSelected(tr){
                if(!(this.offerUser && this.status < 2)) {
                    this.selected = {};
                    return
                }
                this.offerTaskEdit = JSON.parse(JSON.stringify(tr));
                this.editOfferTaskPrompt = true
            },
            updateBranchOffices(){
                const thisIns = this;
                this.$http.get('/api/v1/client/' + this.clientCompanyId + "/branch_offices")
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        if(thisIns.branchOffices.length > 0) thisIns.offerTaskAdding['branch_office_id'] = thisIns.branchOffices[0].id;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateTasks(){
                const thisIns = this;
                this.$http.get('/api/v1/offer/' + this.id + "/task")
                    .then(function (response) {
                        thisIns.tasks = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addOfferTask(){
                const thisIns = this;
                this.$http.post('/api/v1/offer/' + this.id + "/task", {
                    title: this.offerTaskAdding.title,
                    description: this.offerTaskAdding.description,
                    hours: Number(this.offerTaskAdding.hours),
                    deadline_days: Number(this.offerTaskAdding.deadline_days),
                    branch_office_id : Number(this.offerTaskAdding.branch_office_id),
                    quantity:  Number(this.offerTaskAdding.quantity)
                })
                    .then(function () {
                        thisIns.updateTasks();
                        thisIns.addOfferTaskPrompt = false;
                        thisIns.offerTaskAdding.title = '';
                        thisIns.offerTaskAdding.description = '';
                        thisIns.offerTaskAdding.hours = 0;
                        thisIns.offerTaskAdding.quantity = 1;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editOfferTask(){
                const thisIns = this;
                this.$http.put('/api/v1/offer/' + this.id + "/task/" + this.selected.id, {
                    title: this.offerTaskEdit.title,
                    description: this.offerTaskEdit.description,
                    hours: Number(this.offerTaskEdit.hours),
                    deadline_days: Number(this.offerTaskEdit.deadline_days),
                    branch_office_id : Number(this.offerTaskEdit.branch_office_id),
                    quantity : Number(this.offerTaskEdit.quantity)
                })
                    .then(function () {
                        thisIns.updateTasks();
                        thisIns.editOfferTaskPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removeOfferTask(){
                const thisIns = this;
                this.$http.delete('/api/v1/offer/' + this.id + "/task/" + this.selected.id)
                    .then(function () {
                        thisIns.updateTasks();
                        thisIns.editOfferTaskPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            }
        },
        watch: {
            editOfferTaskPrompt: function () {
                if(!this.editOfferTaskPrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            this.updateTasks();
            this.updateBranchOffices();
        }
    }

</script>
